import { gql, TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import {
  MarketplaceAdditionalArgs,
  MarketplaceAssetType,
} from './getPopularMarketplaceAssets';

type GetFavoriteMarktplaceAssets = MarketplaceAssetType;
type GetFavoriteMarktplaceAssetsResponse = {
  marketplaceAssets: DefaultApiResponse<GetFavoriteMarktplaceAssets[]>;
};
type GetFavoriteMarktplaceAssetsArgs = MarketplaceAdditionalArgs;
export const getFavoriteMarketplaceAssetsQuery: TypedDocumentNode<
  GetFavoriteMarktplaceAssetsResponse,
  DefaultArg<{ take?: number }> & GetFavoriteMarktplaceAssetsArgs
> = gql`
  query GetFavoriteMarketplaceAssets(
    $record: MarketplaceAssetsListRecord!
    $changeRecord: AssetsRateChangeRecord!
    $rateRecord: AssetsRateChangeRecord!
  ) {
    marketplaceAssets: getFavoriteMarketplaceAssets(record: $record) {
      change(record: $changeRecord)
      code
      iconUrl
      isFavorite
      name
      rate(record: $rateRecord)
      marketCap
    }
  }
`;
